<script>
	import { onMount, onDestroy, tick } from 'svelte';
	import ComponentPageHead from '$lib/components/ComponentPageHead.svelte';
	import RebrandLayoutSkeleton from '$lib/components/skeletons/RebrandLayoutSkeleton.svelte';
	import {
		instrument,
		markVariantReady,
		markVariantPainted,
		afterPaint,
	} from '$lib/services/sentry';
	export let data;
	const { page } = data;
	let metadata = data.metadata;
	/**
	 * @type {typeof import('svelte').SvelteComponent}
	 */
	let Component;
	let destroyed = false;
	let cancelPaint = () => {};

	onMount(async () => {
		Component = await instrument('page.render', 'Create account render', () => page?.init());
		if (destroyed) return;
		if (page) metadata = { ...page.metadata };
		if (Component) {
			markVariantReady();
			await tick();
			cancelPaint = afterPaint(markVariantPainted);
		}
	});

	onDestroy(() => {
		destroyed = true;
		cancelPaint();
	});
</script>

{#key metadata}
	<ComponentPageHead content={metadata} />
{/key}

{#if Component}
	<svelte:component
		this={Component}
		pageData={data}
	/>
{:else}
	<RebrandLayoutSkeleton routeKey="create-account" />
{/if}
